import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { customerPaymentQueries } from '@/services/customerPaymentLogs/customerPaymentLogs.queries';
import { useSearch } from '@tanstack/react-router';

export const useGetCustomerPaymentLogs = () => {
  const search = useSearch({ from: '/(app)/payment-management/customer-payment-logs/' });
  const { page, fetch, q } = search;

  const { data, isFetched, isLoading } = useQuery({
    ...customerPaymentQueries.list({
      row: page ?? 0,
      fetch: fetch ?? 10,
      search: q,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
    enabled: !!fetch,
  });

  return {
    customerPaymentLogs: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};

export default useGetCustomerPaymentLogs;
